export default __webpack_public_path__ + "static/media/fire.108f3903.svg";